export default __webpack_public_path__ + "static/media/login-bg-35.4bdf6d02.jpg";